// Re-number images sequentially 0-based (0, 1, 2, …) sorted by their current order.
// This absorbs any gaps, 0-vs-1-based inconsistencies, and keeps state canonical.
function normalize(images) {
  return [...images]
    .sort((a, b) => a.order - b.order)
    .map((img, i) => ({ ...img, order: i }));
}

export default function imagesReducer(state, action) {
  switch (action.type) {
    case 'init':
      // action.payload: state
      // Normalize on load to absorb 0-based/1-based inconsistency from the backend
      return {
        ...action.payload,
        images: normalize(action.payload.images),
      };

    case 'add':
      // action.payload: [images]
      // Normalize the full array so new images slot in after existing ones correctly
      return {
        images: normalize(state.images.concat(action.payload)),
      };

    case 'change':
      // action.payload: image
      return {
        ...state,
        images: state.images.map((originalImage) => {
          // Change only the image with the same id, leave the others unchanged
          if (action.payload._id === originalImage._id) {
            return action.payload;
          }
          return originalImage;
        }),
      };

    case 'delete':
      // action.payload: image
      // Normalize after filtering so there are never gaps in order values
      return {
        images: normalize(state.images.filter((image) => image !== action.payload)),
      };

    case 'reorder': {
      const { id, newIndex } = action.payload;

      const movingImage = state.images.find(img => img._id === id);
      if (!movingImage) return state;
      if (movingImage.order === newIndex) return state;

      // When moving UP (to lower index), place before target with -0.5
      // When moving DOWN (to higher index), place after target with +0.5
      const fractionalOrder = newIndex < movingImage.order
        ? newIndex - 0.5
        : newIndex + 0.5;

      const withNewOrder = state.images.map(img =>
        img._id === id ? { ...img, order: fractionalOrder } : img
      );

      return {
        ...state,
        images: normalize(withNewOrder),
      };
    }

    default:
      throw new Error();
  }
}
